import ButtonComponent from '../../component/buttton/ButtonWithLoading.component';
import GridComponentComponent from '../../component/grid/GridComponent.component';
import Select from './components/select/Select.component';
import MultiSelect from './components/multiselect/MultiSelect.component';
import Table from '../../component/table/Table.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import FormLabelComponent from '../../component/input/FormLabel.component';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import {
  DatePickerComponent,
  FormInput,
} from '../../component/input/InputStyle';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import { FormatHours } from '../../utils/format/FormatDate';

import { Region } from '../scheduleMaintenance/regions/interfaces/Region';
import { statusTaskList, typeTaskList } from './utils/ListItens';

import { IFlag } from '../store/utils/Flags';
import { Store } from '../store/interfaces/Store';

import { useTask } from '../../context/Task';
import { useEffect } from 'react';
import { useStore } from '../../context/Store';

const TaskContainer = () => {
  const {
    getAllTasks,
    pagination,
    taskList,
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
    selectStore,
    setSelectStore,
    selectFlag,
    setSelectFlag,
    arrayFlags,
    listStore,
    loadingExport,
    statusTask,
    setStatusTask,
    typeTask,
    setTypeTask,
    verifyToGet,
    exportToJson,
    total,
    request,
    handleChangePage,
    handleRequestSort,
    handleRowPerPage,
    selectRegion,
    setSelectRegion,
    listRegions,
  } = useTask();
  const { getFlags } = useStore();
  const formatArrayFlags = (): string[] => {
    const flagsOptions: string[] = [];

    arrayFlags.forEach((a: IFlag) => {
      flagsOptions.push(a.flag as string);
    });
    return flagsOptions;
  };

  const formatArrayRegions = (): string[] => {
    const regionOptions: string[] = [];
    listRegions.forEach((a: Region) => {
      const flagObj = arrayFlags.find(
        (f) => parseInt(`${f.id}`) === parseInt(`${a.flag_id}`)
      );
      if (selectFlag.includes(`${flagObj?.flag}`)) {
        if (selectFlag.length > 1) {
          regionOptions.push(`${a.description} (${flagObj?.flag})`);
        } else {
          regionOptions.push(`${a.description}`);
        }
      }
    });
    return regionOptions;
  };

  useEffect(() => {
    setSelectStore([]);
    setSelectRegion([]);
    setSelectFlag([]);
    getFlags();
  }, []);

  const formatArrayStores = (): string[] => {
    let storesAux: string[] = [];

    listStore.forEach((store: Store) => {
      const flagObj = arrayFlags.find(
        (f) => parseInt(`${f.id}`) === parseInt(`${store.flag_id}`)
      );
      const regObj = listRegions.find((a: Region) => a.id === store.region_id);

      if (
        selectRegion.includes(`${regObj?.description}`) ||
        selectRegion.includes(`${regObj?.description} (${flagObj?.flag})`)
      ) {
        storesAux.push(store.id as string);
      }
    });
    return storesAux;
  };

  return (
    <>
      <GridComponentComponent
        justify='flex-start'
        alignItems='center'
        spacing={2}
      >
        <MultiSelect
          lg={4}
          required={true}
          disabled={!!loadingExport.message}
          handleSubmitForm={(value) => setSelectFlag(value)}
          title='Bandeiras'
          initialValues={selectFlag}
          listItem={formatArrayFlags()}
        />

        <MultiSelect
          lg={4}
          required={true}
          disabled={selectFlag.length === 0 || !!loadingExport.message}
          handleSubmitForm={(value) => setSelectRegion(value)}
          title='Regionais'
          initialValues={selectRegion}
          listItem={formatArrayRegions()}
        />

        <MultiSelect
          lg={4}
          required={true}
          disabled={
            listStore.length === 0 ||
            selectRegion.length === 0 ||
            !!loadingExport.message
          }
          handleSubmitForm={(value) => setSelectStore(value)}
          title='Lojas'
          initialValues={selectStore}
          listItem={formatArrayStores()}
        />

        <FormLabelComponent
          title='data de início'
          sm={6}
          md={4}
          lg={2}
          required={true}
        >
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale='ptBR'
          >
            <DatePickerComponent
              value={initialDate || null}
              maxDateMessage='data não pode ser maior que Data de Fim'
              maxDate={finalDate || null}
              onChange={(date: Date | string) =>
                setInitialDate(new Date(FormatHours(date, '00:00:00')))
              }
              disabled={!!loadingExport.message}
              renderInput={(props: any) => <FormInput {...props} required />}
            />
          </LocalizationProvider>
        </FormLabelComponent>

        <FormLabelComponent
          title='data fim'
          sm={6}
          md={4}
          lg={2}
          required={true}
        >
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale='ptBR'
          >
            <DatePickerComponent
              value={finalDate || null}
              maxDateMessage='data não pode ser maior que Data de Fim'
              minDate={initialDate || null}
              onChange={(date: Date | string) =>
                setFinalDate(new Date(FormatHours(date, '23:59:59').toString()))
              }
              disabled={!!loadingExport.message}
              renderInput={(props: any) => <FormInput {...props} required />}
            />
          </LocalizationProvider>
        </FormLabelComponent>

        <Select
          disabled={!!loadingExport.message}
          required={true}
          handleSubmitForm={(value) => setStatusTask(value.toString())}
          title='Status tarefa'
          initialValues={statusTask}
          listItem={statusTaskList}
        />

        <Select
          disabled={!!loadingExport.message}
          required={true}
          handleSubmitForm={(value) => setTypeTask(value.toString())}
          title='Tipo tarefa'
          initialValues={typeTask}
          listItem={typeTaskList}
        />
      </GridComponentComponent>
      <GridComponentComponent
        justify='flex-end'
        alignItems='center'
        margin='28px 0 0 0'
        spacing={2}
      >
        <ButtonComponent
          disabled={!!loadingExport.message || request}
          onClick={() => verifyToGet() && getAllTasks()}
          title='pesquisar'
          loading={request}
          size='medium'
        />

        {taskList.length > 0 && (
          <ButtonComponent
            margin='0 0 0 8px'
            onClick={exportToJson}
            title='Excel'
            size='medium'
            loading={request}
            disabled={!!loadingExport.message || request}
          />
        )}
      </GridComponentComponent>

      <div style={{ margin: '20px 0' }}></div>
      <Table
        size={total}
        noActionEdit
        request={request}
        data={taskList}
        headCells={HEAD_CELL}
        noActionView
        page={pagination.page}
        rowsPerPage={pagination.perPage}
        onChangePage={loadingExport.message ? () => false : handleChangePage}
        order={pagination.order === 1 ? 'asc' : 'desc'}
        orderBy={pagination.sort}
        onRequestSort={loadingExport.message ? () => false : handleRequestSort}
        onChangeRowsPerPage={
          loadingExport.message ? () => false : handleRowPerPage
        }
      />
    </>
  );
};

export default TaskContainer;
